<script setup lang="ts">
const emit = defineEmits(['mouseenter', 'mouseleave'])

const _props = defineProps<{
  markActive?: boolean
  classes?: string
  items?: {
    url?: string
    label?: string
    text?: string
    media?: unknown
    page?: unknown
  }[]
}>()
</script>

<template>
  <ul class="links">
    <li
      v-for="(link, index) in items"
      :key="index"
      class="link-item relative py-3.5 font-medium"
      :class="classes"
    >
      <CommonBasicLink
        :link="link"
        class="group relative"
        @mouseenter="(e) => emit('mouseenter', e)"
        @mouseleave="(e) => emit('mouseleave', e)"
      >
        <div class="link relative flex items-center">
          <span class="font-base transition group-hover:translate-x-2">
            {{ link.label }}
          </span>
        </div>
      </CommonBasicLink>
    </li>
  </ul>
</template>
